module.exports = "/dist/d9e11714b6724063c0b14e783c1be40b.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-700.eot
// module id = 18
// module chunks = 0